import { api } from './configs/axiosConfig';

const endPoint = "/sales";

export const salesAPI = {
    getSalesDetailsRpt: async function (pCode, locCode, locName, cusCode, fromDate, toDate) {
        const reponse = await api.request({
            url: `${endPoint}/details-report`,
            method: 'GET',
            params: { pCode, locCode, locName, cusCode, fromDate, toDate }
        });

        return reponse.data;
    },

    getSalesComparison: async function () {
        const reponse = await api.request({
            url: `${endPoint}/comparison-graph`,
            method: 'GET',

        });

        return reponse.data;
    }
}